import { DirectionEnum, ModeOfTravelEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";

const useModeOfTravel = () => {
    const { clearRoutes, setModeOfTravel, setTripType } =
        useBookingStore();

    const selectMode = (value: ModeOfTravelEnum) => {
        setModeOfTravel(value);

        if (value === ModeOfTravelEnum.FlyAndSail ||
            value === ModeOfTravelEnum.SailAndFly) {
            setTripType(DirectionEnum.Return);
        }
        
        clearRoutes();
    };

    return {
        selectMode
    }
}

export default useModeOfTravel;